import { Component, Input, OnInit, NgModule } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-common-confirm',
  template: `
  <p-confirmDialog #confirm [key]="confirmKey" header="Confirmation" icon="pi pi-exclamation-triangle" [style]="{width: '30vw'}" [baseZIndex]="100000">
    <ng-template pTemplate="footer">
      <button
        type="button"
        pButton
        icon="pi pi-check"
        label="确认"
        (click)="confirm.accept()"
      ></button>
      <button
        type="button"
        pButton
        icon="pi pi-times"
        label="取消"
        class="p-button-raised p-button-text p-button-plain"
        (click)="confirm.reject()"
      ></button>
    </ng-template>
  </p-confirmDialog>
  `
})
export class CommonConfirmComponent implements OnInit {

  @Input() confirmKey = 'confirm';

  constructor() { }

  ngOnInit(): void {
  }

}

@NgModule({
    imports: [ConfirmDialogModule],
    exports: [CommonConfirmComponent],
    declarations: [CommonConfirmComponent]
})
export class CommonConfirmModule { }
